import React from 'react'
import {
  OptionWrapper,
  OptionWrapperProps,
} from 'src/editor/layout/sidebar/settings/option-wrapper'
import { Input, InputProps } from 'src/editor/shared/ui-lib/input'

interface TextInputControlProps
  extends Omit<InputProps, 'onChange' | 'onReset' | 'width' | 'className'>,
    OptionWrapperProps {
  update: (value: string) => void
  wrapperProps?: OptionWrapperProps
}

export const TextInputControl = ({
  wrapperProps,
  update,
  ...props
}: TextInputControlProps) => {
  return (
    <OptionWrapper {...wrapperProps}>
      <Input onChange={update} width="w-full" {...props} />
    </OptionWrapper>
  )
}
